
<script>
	import listBase from '@_system/components/base/list.vue'
	import receiptIndex from './lib/receipt/index.vue'
	import invoicewriteoffIndex from './lib/invoicewriteoff/index.vue'
	export default {
		extends: listBase,
		name: 'paymentapplicationIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showUnsendjindie} onChange={this.showUnsendjindieChange} active-text="显示未同步" inactive-text=""></el-switch>,
				<el-switch style="padding-left:20px" v-model={this.showUnuploadinvoice} onChange={this.showUnuploadinvoiceChange} active-text="显示发票未上传" inactive-text=""></el-switch>,
				// <el-switch style="padding-left:20px" v-model={this.showOffset} onChange={this.offsetChange} active-text="显示冲抵预收款" inactive-text=""></el-switch>,
			]
			this.$slots.plug = [
				<receipt-index ref="receiptBox" param={this.param} />,
				<invoicewriteoff-index ref="invoicewriteoffIndex"  />
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				showUnsendjindie:false,
				showUnuploadinvoice:false,
				moduleName: 'paymentapplication',
				windowName: '付款申请',
				windowType: 'modal',
				param:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
	
			invoicewriteoff(){
				// let res = this.getOptimalPurchase(15000,0,10000,0.5)
				// console.log(res)
				this.$refs.invoicewriteoffIndex.modal_show()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},
			showUnuploadinvoiceChange(e){
				this.foreingKey.showUnuploadinvoice = e?1:0
				this.customreload()
			},
			offsetChange(e){
				this.foreingKey.offset = e?1:0
				this.customreload()
			},
			beforeCreateGrid(formConfig,columns,gridOptions){	
				gridOptions.checkboxConfig = null
				columns.unshift({
					type: 'checkbox',
					title: '',
					field:'',
					fixed:'left',
					width:50
				},{
					field: 'jindie_status',
					title: '金蝶',
					fixed:'right',
					width:100,
					formatter:({row})=>{
						if(row.export_jindie==1){
							if(row.export_jindie_sucess==1){
								return '已同步'
							}else{
								if(row.export_jindie_error){
									let error = row.export_jindie_error.map((item)=>{
										return item.Message
									})
									//console.log(row.export_jindie_error)
									return error.join(',')
								}else{
									return '同步失败'
								}
							}
						}else{
							return '未同步'
						}
					}
				})
				columns.forEach((item)=>{
					if(item.field=='reslut'){
						item.slots = {
							default:(params)=>{
								return <div>
											<i style="margin-right:6px;cursor: pointer;font-size:14px" onClick={()=>{this.getStatus(params.row)}} class="el-icon-refresh-left"></i>
											<span>{params.row.reslut?params.row.reslut:''}</span>
										</div>
							}
						}
					}
				})
			},
			afterGet(res){
				res.list.forEach((item)=>{
					let codetag = []
					if(item.invoicefile){
						codetag.push({type:'danger',value:'票',content:'发票已上传'})
					}
					item.extend_tag = [
						{field:'code',tag:codetag},
						// {field:'customercode',tag:customercodetag}
					]
				})
			},
			sendjindie(){
				let data =  this.getGrid().getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.loading = true
				let ids = data.map((item)=>{
					return item.id
				})
				this.$api.paymentapplication.sendjindie({ids:ids}).then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
				
			},
			add() {
				this.$confirm('请选择付款对', '提示', {
					confirmButtonText: '供应商',
					cancelButtonText: '售后',
					type: 'warning',
					distinguishCancelAndClose:true
				}).then(()=>{
					this.$confirm('请选择供应商类型', '提示', {
						confirmButtonText: '现结',
						cancelButtonText: '月付',
						type: 'warning',
						distinguishCancelAndClose:true
					}).then(()=>{
						this.addformShow()
					}).catch((e)=>{
						if(e=='cancel'){
							this.addformShow({
								componentname:'monthpaymentform'
							})
						}							
					})
				}).catch((e)=>{
					if(e=='cancel'){
						//alert('售后')
						this.addformShow({
							componentname:'exchangepaymentform'
						})
					}
			
				})
			},
			edit(row) {
				if(row.ordertype == 'FK'){
					this.editformShow(row,{
						componentname:'monthpaymentform'
					})
				}else if(row.ordertype == 'SH'){
					this.editformShow(row,{
						componentname:'exchangepaymentform'
					})
				}else{
					this.editformShow(row)
				}
			},
			receipt(row) {
				this.param = {code:row.code}
				this.$nextTick(()=>{
					this.$refs.receiptBox.modalShow()
				})
				
				
				// let handle = this.$loading()
				// this.$api.paymentapplication.getReceiptInfo({
				// 	supplierwlnid: row.supplierwlnid,
				// 	id: row.id,
				// 	type: row.ordertype
				// }).then((res) => {
				// 	this.receiptInfo = res
				// 	this.$loadingclose(handle)
				// 	this.$refs.receiptBox.modalShow()
					
				// },()=>{
				// 	this.$loadingclose(handle)
				// })
			},
			getStatus(row){
				//console.log(row)
				let handle = this.$loading()
				this.$api.paymentapplication.status({
					id: row.id,
					code: row.purchasecode,
					type: row.ordertype
				}).then((res) => {
					row.reslut = res
					this.$loadingclose(handle)
				},()=>{
					this.$loadingclose(handle)
				})
			}
		},
		components: {
			receiptIndex,
			invoicewriteoffIndex
		}
	}
</script>
